import { useNode } from '@craftjs/core';
import { AutocompleteControl } from 'pages/PageEditor/settingsComponents';
import React, { useCallback, useMemo } from 'react';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import { CountryCodes } from '@descope/page-editor-components';
import { EditorLoginIdInputSettings } from '../EditorLoginIdInputSettings';
import { autoDetectOption, countryCodeOptions } from './editorPhoneConstants';

const EditorPhoneSettings = () => {
	const {
		autoDetect,
		defaultValue,
		actions: { setProp }
	} = useNode((node) => ({
		nodeId: node.id,
		autoDetect: node.data.props.autoDetect,
		defaultValue: node.data.props.defaultValue
	}));

	const [onAutoDetectChange, onDefaultValueChange] = useMemo(
		() =>
			['autoDetect', 'defaultValue'].map((attr) =>
				generateOnChange(setProp, attr)
			),
		[setProp]
	);

	const onDefaultCountryChange = useCallback(
		(value: string) => {
			const isAutoDetect = value === autoDetectOption;
			onAutoDetectChange(isAutoDetect);
			onDefaultValueChange(isAutoDetect ? '' : value);
		},
		[onAutoDetectChange, onDefaultValueChange]
	);

	const defaultCountry = useMemo(
		() => (autoDetect ? autoDetectOption : defaultValue),
		[autoDetect, defaultValue]
	);

	return (
		<EditorLoginIdInputSettings>
			<AutocompleteControl
				popperProps={{
					style: { width: 260, paddingRight: 16 },
					disablePortal: false
				}}
				label={intl.tr('screenEditor.settings.phone.defaultCountry')}
				setValue={onDefaultCountryChange}
				value={defaultCountry}
				options={countryCodeOptions}
				getOptionLabel={(o) => {
					if (o === autoDetectOption)
						return intl.tr(
							'screenEditor.settings.phone.defaultCountry.autoDetect'
						);

					const country = CountryCodes.find((c) => c.code === o);
					return `${country?.name} (${country?.code}) ${country?.dialCode}`;
				}}
				order={25}
				helpTooltip={intl.tr(
					'screenEditor.settings.phone.defaultCountry.tooltip'
				)}
			/>
		</EditorLoginIdInputSettings>
	);
};

export { EditorPhoneSettings };
